import { render, staticRenderFns } from "./Compartir.vue?vue&type=template&id=c348cd94&scoped=true&"
import script from "./Compartir.vue?vue&type=script&lang=js&"
export * from "./Compartir.vue?vue&type=script&lang=js&"
import style0 from "./Compartir.vue?vue&type=style&index=0&id=c348cd94&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c348cd94",
  null
  
)

export default component.exports